import React from 'react';
import LocalizationMisc from '../miscs/LocalizationMisc';
type Props = {
  width: number,
  height: number
}

const EmptyLayout = ( props: Props ) => {
  return ( <div style={{...props}} className='EmptyLayout'><div>{LocalizationMisc.local( 'layout.empty' )}</div></div> )
}

export default EmptyLayout;
